import {
	Directive,
	OnInit,
	TemplateRef,
	ViewContainerRef
} from "@angular/core";
import { environment } from "@env";

@Directive({
	selector: "[appProdEnv]"
})
export class ProdEnvDirective implements OnInit {
	constructor(
		private templateRef: TemplateRef<unknown>,
		private viewContainer: ViewContainerRef
	) {}

	ngOnInit(): void {
		if (environment.production) {
			this.viewContainer.createEmbeddedView(this.templateRef);
			return;
		}
		this.viewContainer.clear();
	}
}
